import React, { Component } from 'react';
import ReconciliationController from './reconciliation.controller';
import withHooks from '../../core/withHooks';
import Inherit from '../../core/inherit';
import { Card, Layout, Title } from '../common';
import ReconciliationTable from './elements/ReconciliationTable';
import ReconciliationTableActions from './elements/ReconciliationTableActions';

class Reconciliation extends Inherit(ReconciliationController, Component) {
    state = { user: {}, loading: true, reconciliation: [], rows: [] };

    render() {
        const { user, loading, reconciliation, rows } = this.state;
        return (
            <Layout user={user} fi={user?.fi?.name}>
                <Title title="Reconciliation" />
                <ReconciliationTableActions setRows={this.setRows.bind(this)} reconciliation={reconciliation} rows={rows} />
                <Card>
                    <ReconciliationTable rows={rows} loading={loading} />
                </Card>
            </Layout>
        );
    }
}

export default withHooks(Reconciliation);
